const SECONDS_PER_MINUTE = 60;

export const secondsToWholeMinuteTimeString = (seconds: number) =>
	`${Math.round(seconds / SECONDS_PER_MINUTE)}m`;

export default secondsToWholeMinuteTimeString;
